import _inheritsLoose from '@babel/runtime/helpers/esm/inheritsLoose';
import React from 'react';
import PropTypes from 'prop-types';
import Draggable from 'react-draggable';
import _extends from '@babel/runtime/helpers/esm/extends';
import { VariableSizeList } from 'react-window';
import classNames from 'classnames';
import memoize from 'memoize-one';

var Column = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Column, _React$Component);

  function Column() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Column.prototype;

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement("span", null);
  };

  return Column;
}(React.Component);

Column.propTypes = {
  /**
   * Content cell render function
   */
  cellRenderer: PropTypes.func,

  /**
   * Column header cell render function
   */
  columnHeaderCellRenderer: PropTypes.func,

  /**
   * Field key containing data
   */
  dataKey: PropTypes.string,

  /**
   * Default column width in pixels
   */
  width: PropTypes.number
};

var ColumnResizer = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ColumnResizer, _React$Component);

  function ColumnResizer() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handleDrag = function (event, data) {
      var onResizeColumn = _this.props.onResizeColumn;
      onResizeColumn(data.x);
    };

    _this.handleClick = function (event) {
      event.stopPropagation();
    };

    return _this;
  }

  var _proto = ColumnResizer.prototype;

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement(Draggable, {
      axis: "x",
      defaultClassName: 'VTColumnResizer',
      defaultClassNameDragging: 'VTColumnResizerActive',
      onStop: this.handleDrag,
      position: {
        x: 0,
        y: 0
      },
      zIndex: 999
    }, /*#__PURE__*/React.createElement("div", {
      className: "VTColumnResizer",
      onClick: this.handleClick
    }));
  };

  return ColumnResizer;
}(React.Component);

ColumnResizer.propTypes = {
  /**
   * Action on resize column
   */
  onResizeColumn: PropTypes.func.isRequired
};

var Header = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Header, _React$Component);

  function Header() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Header.prototype;

  _proto.render = function render() {
    var _this = this;

    var _this$props = this.props,
        children = _this$props.children,
        getHeaderWidth = _this$props.getHeaderWidth,
        getHeaderHeight = _this$props.getHeaderHeight,
        getColumnWidth = _this$props.getColumnWidth,
        _onResizeColumn = _this$props.onResizeColumn,
        sortIndicatorRenderer = _this$props.sortIndicatorRenderer,
        overflowWidth = _this$props.overflowWidth,
        headerClassName = _this$props.headerClassName,
        headerCellClassName = _this$props.headerCellClassName,
        disableColumnsResizable = _this$props.disableColumnsResizable;
    var idx = 0;
    return /*#__PURE__*/React.createElement("div", {
      className: classNames('VTHeader', headerClassName),
      style: {
        width: getHeaderWidth(),
        height: getHeaderHeight()
      },
      ref: function ref(i) {
        return _this.headerEl = i;
      }
    }, React.Children.map(children, function (child) {
      var columnIndex = idx; //New in deecoob fork

      var headerCellsClassName = headerCellClassName && headerCellClassName(columnIndex);

      if (!child) {
        return null;
      }

      var _child$props = child.props,
          label = _child$props.label,
          dataKey = _child$props.dataKey,
          columnHeaderCellRenderer = _child$props.columnHeaderCellRenderer;
      var width = getColumnWidth(columnIndex);
      var content;

      if (columnHeaderCellRenderer) {
        content = columnHeaderCellRenderer({
          label: label,
          dataKey: dataKey,
          columnIndex: columnIndex
        });
      } else {
        content = /*#__PURE__*/React.createElement("div", {
          className: "VTCellContent",
          title: label
        }, label);
      }

      var getAction = function getAction(actionName) {
        var action = _this.props[actionName];

        if (action) {
          return function (event) {
            return action(event, {
              dataKey: dataKey,
              columnIndex: columnIndex
            });
          };
        }
      };

      idx += 1; //new in deecoob fork: new headerCellsClassName and option to enable sorting at the same time as column resizing

      return /*#__PURE__*/React.createElement("div", {
        className: classNames('VTHeaderCell', headerCellsClassName, !disableColumnsResizable && 'sortable'),
        onClick: getAction('onClick'),
        onDoubleClick: getAction('onDoubleClick'),
        onMouseOver: getAction('onMouseOver'),
        onMouseOut: getAction('onMouseOut'),
        onContextMenu: getAction('onRightClick')
      }, content, !disableColumnsResizable && /*#__PURE__*/React.createElement(ColumnResizer, {
        onResizeColumn: function onResizeColumn(diff) {
          return _onResizeColumn(columnIndex, diff, dataKey);
        }
      }), sortIndicatorRenderer({
        dataKey: child.props.dataKey,
        columnIndex: columnIndex
      }));
    }), /*#__PURE__*/React.createElement("div", {
      className: "VTHeaderCell",
      style: {
        minWidth: overflowWidth,
        maxWidth: overflowWidth
      }
    }));
  };

  return Header;
}(React.Component);

Header.propTypes = {
  children: PropTypes.array,
  getHeaderWidth: PropTypes.func.isRequired,
  getHeaderHeight: PropTypes.func.isRequired,
  getColumnWidth: PropTypes.func.isRequired,
  height: PropTypes.number.isRequired,
  onClick: PropTypes.func,
  onDoubleClick: PropTypes.func,
  onMouseOver: PropTypes.func,
  onMouseOut: PropTypes.func,
  onRightClick: PropTypes.func,
  onResizeColumn: PropTypes.func,
  sortIndicatorRenderer: PropTypes.func,
  headerClassName: PropTypes.string,
  headerCellClassName: PropTypes.func,
  disableColumnsResizable: PropTypes.bool
};
Header.defaultProps = {
  onResizeColumn: function onResizeColumn(f) {
    return f;
  },
  sortIndicatorRenderer: function sortIndicatorRenderer() {
    return null;
  }
};

var Row = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(Row, _React$PureComponent);

  function Row() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = Row.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        data = _this$props.data,
        index = _this$props.index,
        style = _this$props.style;
    var _data$rowProps = data.rowProps,
        dataList = _data$rowProps.dataList,
        getRowData = _data$rowProps.getRowData,
        getRowWidth = _data$rowProps.getRowWidth,
        rowClassName = _data$rowProps.rowClassName,
        getCellValue = _data$rowProps.getCellValue,
        getColumnWidth = _data$rowProps.getColumnWidth,
        children = _data$rowProps.children,
        onClick = _data$rowProps.onClick,
        onDoubleClick = _data$rowProps.onDoubleClick,
        onMouseOver = _data$rowProps.onMouseOver,
        onMouseOut = _data$rowProps.onMouseOut,
        onMouseDown = _data$rowProps.onMouseDown,
        onMouseUp = _data$rowProps.onMouseUp,
        onRightClick = _data$rowProps.onRightClick;
    style = _extends({}, style);
    var evenClassName = index % 2 === 0 ? 'VTRowOdd' : 'VTRowEven';
    var customClassName = rowClassName && rowClassName(index);
    var rowData = getRowData(index, dataList);
    var idx = 0;
    return /*#__PURE__*/React.createElement("div", {
      className: classNames('VTRow', evenClassName, customClassName),
      style: style,
      onClick: onClick,
      onDoubleClick: onDoubleClick,
      onMouseOver: onMouseOver,
      onMouseOut: onMouseOut,
      onContextMenu: onRightClick,
      onMouseDown: onMouseDown,
      onMouseUp: onMouseUp,
      "data-row-index": index
    }, React.Children.map(children, function (child) {
      if (!child) {
        return null;
      }

      var _child$props = child.props,
          cellRenderer = _child$props.cellRenderer,
          dataKey = _child$props.dataKey;
      var width = getColumnWidth(idx);
      var content;

      if (cellRenderer) {
        content = cellRenderer({
          dataKey: dataKey,
          rowData: rowData,
          columnIndex: idx,
          rowIndex: index
        });
      } else {
        var contentStr = getCellValue({
          rowData: rowData,
          dataKey: dataKey
        });
        content = /*#__PURE__*/React.createElement("div", {
          className: "VTCellContent",
          title: contentStr
        }, contentStr);
      }

      idx += 1;
      return /*#__PURE__*/React.createElement("div", {
        className: classNames('VTCell', dataKey)
      }, content);
    }));
  };

  return Row;
}(React.PureComponent);

Row.propTypes = {
  /**
   * Row index number
   */
  index: PropTypes.number,

  /**
   * Row style object
   */
  style: PropTypes.object,

  /**
   * Table columns array
   */
  children: PropTypes.array,

  /**
   * Row className determine function
   */
  rowClassName: PropTypes.func,

  /**
   * Function to get cell value
   */
  getCellValue: PropTypes.func,

  /**
   * Function to get column width
   */
  getColumnWidth: PropTypes.func,

  /**
   *  Mouse actions
   */
  onClick: PropTypes.func,
  onDoubleClick: PropTypes.func,
  onMouseOver: PropTypes.func,
  onMouseOut: PropTypes.func,
  onMouseDown: PropTypes.func,
  onMouseUp: PropTypes.func,
  onRightClick: PropTypes.func
};

var countChildren = function countChildren(children) {
  var count = 0;
  React.Children.forEach(children, function (child) {
    if (child) {
      count += 1;
    }
  });
  return count;
};

var getItemData = /*#__PURE__*/memoize(function (dataList, rowProps) {
  return {
    dataList: dataList,
    rowProps: rowProps
  };
});

var Table = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Table, _React$Component);

  var _proto = Table.prototype;

  _proto.calculateCustomColumnsWidth = function calculateCustomColumnsWidth() {
    var _this$props = this.props,
        children = _this$props.children,
        overflowWidth = _this$props.overflowWidth,
        width = _this$props.width,
        minColumnWidth = _this$props.minColumnWidth,
        dynamicColumnWidth = _this$props.dynamicColumnWidth;
    var customColumnsWidth = [];
    var customColumnsCount = 0;
    var customColumnsWidthSum = 0;
    React.Children.forEach(children, function (child) {
      if (!child) {
        return;
      }

      var width = child.props.width;

      if (Number.isInteger(width)) {
        width = Math.max(width, minColumnWidth);
        customColumnsCount += 1;
        customColumnsWidthSum += width;
      }

      customColumnsWidth.push(width || undefined);
    });

    if (!dynamicColumnWidth) {
      //Fill other width averaged width values
      var defaultWidth = Math.max((width - overflowWidth - customColumnsWidthSum) / (this.getColumnsCount() - customColumnsCount), minColumnWidth);
      customColumnsWidth = customColumnsWidth.map(function (item) {
        if (item === undefined) {
          return defaultWidth;
        }

        return item;
      });
    }

    return customColumnsWidth;
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    this.rowWidth = null;

    if (countChildren(prevProps.children) !== countChildren(this.props.children)) {
      this.setState({
        customColumnsWidth: this.calculateCustomColumnsWidth()
      });
    }

    if (this.autoScrolling && this.props.autoScroll && this.props.data) {
      this.scrollToItem(this.props.data.size);
    }
  };

  function Table(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      customColumnsWidth: []
    };
    _this.autoScrolling = _this.props.autoScroll;
    _this.rowWidth = null;

    _this.getColumnWidth = function (columnIndex) {
      var _this$props2 = _this.props,
          width = _this$props2.width,
          overflowWidth = _this$props2.overflowWidth,
          minColumnWidth = _this$props2.minColumnWidth,
          dynamicColumnWidth = _this$props2.dynamicColumnWidth;
      var customColumnsWidth = _this.state.customColumnsWidth;

      if (!dynamicColumnWidth) {
        return customColumnsWidth[columnIndex];
      }

      if (customColumnsWidth[columnIndex]) {
        return customColumnsWidth[columnIndex];
      }

      var customColumnsWidthSum = 0;
      var customColumnsCount = 0;
      customColumnsWidth.forEach(function (item) {
        if (item) {
          customColumnsCount += 1;
          customColumnsWidthSum += item;
        }
      });
      return Math.max((width - overflowWidth - customColumnsWidthSum) / (_this.getColumnsCount() - customColumnsCount), minColumnWidth);
    };

    _this.getRowHeight = function (index) {
      var rowHeight = _this.props.rowHeight;

      if (typeof rowHeight === 'function') {
        return rowHeight(index);
      }

      return rowHeight;
    };

    _this.getEstimatedItemSize = function () {
      var data = _this.props.data;
      var total = data.reduce(function (total, item, idx) {
        return total + _this.getRowHeight(idx);
      }, 0);
      return Math.floor(total / _this.getDataSize());
    };

    _this.getHeaderHeight = function () {
      var _this$props3 = _this.props,
          headerHeight = _this$props3.headerHeight,
          disableHeader = _this$props3.disableHeader;

      if (disableHeader) {
        return 0;
      }

      if (typeof headerHeight === 'function') {
        return headerHeight();
      }

      return headerHeight;
    };

    _this.getRowData = function (index, data) {
      data = data || _this.props.data;

      if (typeof data.toJS === 'function') {
        console.log(data);
        debugger;
        return data.get(index);
      } else {
        return data[index];
      }
    };

    _this.getCellValue = function (_ref) {
      var rowData = _ref.rowData,
          dataKey = _ref.dataKey;

      if (typeof rowData.toJS === 'function') {
        return rowData.get(dataKey);
      } else {
        return rowData[dataKey];
      }
    };

    _this.getDataSize = function () {
      var data = _this.props.data;

      if (typeof data.toJS === 'function') {
        return data.size;
      } else {
        return data.length;
      }
    };

    _this.getRowWidth = function () {
      var customColumnsWidth = _this.state.customColumnsWidth;

      if (_this.rowWidth === null) {
        _this.rowWidth = customColumnsWidth.reduce(function (result, item, idx) {
          return result + _this.getColumnWidth(idx);
        }, 0);
      }

      return _this.rowWidth;
    };

    _this.handleResizeColumn = function (columnIndex, diff, dataKey) {
      var _this$props4 = _this.props,
          minColumnWidth = _this$props4.minColumnWidth,
          maxColumnWidth = _this$props4.maxColumnWidth,
          onResizeColumn = _this$props4.onResizeColumn;
      var customColumnsWidth = _this.state.customColumnsWidth;

      var columnWidth = _this.getColumnWidth(columnIndex);

      var newCustomColumnsWidth = [].concat(customColumnsWidth);
      var newWidth = Math.max(columnWidth + diff, minColumnWidth);

      if (maxColumnWidth) {
        newWidth = Math.min(newCustomColumnsWidth[columnIndex], maxColumnWidth);
      }

      newCustomColumnsWidth[columnIndex] = newWidth;

      _this.setState({
        customColumnsWidth: newCustomColumnsWidth
      });

      _this.list && _this.list.resetAfterIndex(0);
      onResizeColumn({
        dataKey: dataKey,
        columnIndex: columnIndex,
        resizeDiff: diff,
        newWidth: newWidth
      });
    };

    _this.getRowHandler = function (actionType) {
      if (!_this["handleRow" + actionType]) {
        _this["handleRow" + actionType] = function (event) {
          var action = _this.props["onRow" + actionType];

          if (action) {
            var rowIndex = Number(event.currentTarget.dataset.rowIndex);

            var rowData = _this.getRowData(rowIndex);

            action(event, {
              rowIndex: rowIndex,
              rowData: rowData
            });
          }
        };
      }

      return _this["handleRow" + actionType];
    };

    _this.handleScroll = function (_ref2) {
      var scrollDirection = _ref2.scrollDirection,
          scrollOffset = _ref2.scrollOffset,
          scrollUpdateWasRequested = _ref2.scrollUpdateWasRequested;
      var onScroll = _this.props.onScroll; //react-window fires onScroll every time on mount, fixing it using this condition

      if (!(!onScroll || scrollDirection === 'forward' && scrollOffset === 0 && !scrollUpdateWasRequested)) {
        onScroll({
          scrollDirection: scrollDirection,
          scrollOffset: scrollOffset,
          scrollUpdateWasRequested: scrollUpdateWasRequested
        });
      }

      if (_this.props.autoScroll && !scrollUpdateWasRequested) {
        var scrollHeight = _this.listOuter.scrollHeight;
        var clientHeight = _this.listOuter.offsetHeight;
        _this.autoScrolling = scrollHeight === clientHeight + scrollOffset;
      }
    };

    _this.state.customColumnsWidth = _this.calculateCustomColumnsWidth();
    return _this;
  }

  _proto.getColumnsCount = function getColumnsCount() {
    var children = this.props.children;
    var total = 0;
    React.Children.forEach(children, function (child) {
      if (child && child.type === Column) {
        total += 1;
      }
    });
    return total;
  };

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var disableHeader = this.props.disableHeader;

    if (!disableHeader) {
      this.listOuter && this.listOuter.addEventListener('scroll', function (e) {
        _this2.header.headerEl.scrollLeft = e.target.scrollLeft;
      });
    }
  };

  _proto.scrollTo = function scrollTo(scrollOffset) {
    this.list && this.list.scrollTo(scrollOffset);
  };

  _proto.scrollToItem = function scrollToItem(index, align) {
    this.list && this.list.scrollToItem(index, align);
  };

  _proto.resetAfterIndex = function resetAfterIndex(index) {
    this.list && this.list.resetAfterIndex(index);
  };

  _proto.renderHeader = function renderHeader(_ref3) {
    var _this3 = this;

    var getHeaderWidth = _ref3.getHeaderWidth;
    var _this$props5 = this.props,
        children = _this$props5.children,
        disableHeader = _this$props5.disableHeader,
        headerHeight = _this$props5.headerHeight,
        sortIndicatorRenderer = _this$props5.sortIndicatorRenderer,
        overflowWidth = _this$props5.overflowWidth;

    if (disableHeader) {
      return null;
    } //New on deecoob fork, classNames for header, headercells and enabling column resizing and sorting


    var componentProps = {
      children: children,
      overflowWidth: overflowWidth,
      headerClassName: this.props.headerClassName,
      headerCellClassName: this.props.headerCellClassName,
      disableColumnsResizable: this.props.disableColumnsResizable,
      height: headerHeight,
      getColumnWidth: this.getColumnWidth,
      getHeaderWidth: getHeaderWidth,
      getHeaderHeight: this.getHeaderHeight,
      onResizeColumn: this.handleResizeColumn,
      onClick: this.props.onHeaderClick,
      onDoubleClick: this.props.onHeaderDoubleClick,
      onMouseOver: this.props.onHeaderMouseOver,
      onMouseOut: this.props.onHeaderMouseOut,
      onRightClick: this.props.onHeaderRightClick,
      sortIndicatorRenderer: sortIndicatorRenderer,
      ref: function ref(i) {
        return _this3.header = i;
      }
    };
    return /*#__PURE__*/React.createElement(Header, componentProps);
  };

  _proto.renderRow = function renderRow() {
    var rowRenderer = this.props.rowRenderer;
    return rowRenderer ? rowRenderer : Row;
  };

  _proto.renderNoItemsLabel = function renderNoItemsLabel() {
    var noItemsLabel = this.props.noItemsLabel;
    return /*#__PURE__*/React.createElement("div", {
      className: "VTNoItemsLabel"
    }, noItemsLabel);
  };

  _proto.render = function render() {
    var _this4 = this;

    var _this$props6 = this.props,
        height = _this$props6.height,
        width = _this$props6.width,
        listProps = _this$props6.listProps,
        className = _this$props6.className,
        data = _this$props6.data,
        rowClassName = _this$props6.rowClassName,
        children = _this$props6.children;
    var rowProps = {
      children: children,
      rowClassName: rowClassName,
      getRowData: this.getRowData,
      getRowWidth: this.getRowWidth,
      getCellValue: this.getCellValue,
      getColumnWidth: this.getColumnWidth,
      onClick: this.getRowHandler('Click'),
      onDoubleClick: this.getRowHandler('DoubleClick'),
      onMouseOver: this.getRowHandler('MouseOver'),
      onMouseOut: this.getRowHandler('MouseOut'),
      onMouseDown: this.getRowHandler('MouseDown'),
      onMouseUp: this.getRowHandler('MouseUp'),
      onRightClick: this.getRowHandler('RightClick')
    };
    var itemData = getItemData(data, rowProps);

    var getHeaderWidth = function getHeaderWidth() {
      return width - 2;
    };

    return /*#__PURE__*/React.createElement("div", {
      className: classNames('VTContainer', className),
      style: {
        paddingTop: this.getHeaderHeight(),
        width: width
      }
    }, this.renderHeader({
      getHeaderWidth: getHeaderWidth
    }), this.getDataSize() ? /*#__PURE__*/React.createElement(VariableSizeList, _extends({
      ref: function ref(i) {
        return _this4.list = i;
      },
      innerRef: function innerRef(i) {
        return _this4.listInner = i;
      },
      outerRef: function outerRef(i) {
        return _this4.listOuter = i;
      },
      className: "VTList",
      height: height - this.getHeaderHeight(),
      itemCount: this.getDataSize(),
      itemSize: this.getRowHeight,
      itemData: itemData,
      width: width - 2,
      onScroll: this.handleScroll,
      estimatedItemSize: this.getEstimatedItemSize()
    }, listProps), this.renderRow()) : this.renderNoItemsLabel());
  };

  return Table;
}(React.Component);

Table.propTypes = {
  /**
   * Table width
   */
  width: PropTypes.number.isRequired,

  /**
   * Table height
   */
  height: PropTypes.number.isRequired,

  /**
   * Table header height
   */
  headerHeight: /*#__PURE__*/PropTypes.oneOfType([PropTypes.number, PropTypes.func]),

  /**
   * Table row height (may be function)
   *
   * @param {Number} index Порядковый номер элемента в списке данных
   */
  rowHeight: /*#__PURE__*/PropTypes.oneOfType([PropTypes.number, PropTypes.func]),

  /**
   * Data list
   */
  data: PropTypes.any.isRequired,

  /**
   * Row className determine function
   */
  rowClassName: PropTypes.func,

  /**
   * Personal row renderer function (If nothing return, then internal row function will be applied)
   *
   * @param {object} props
   */
  rowRenderer: PropTypes.func,

  /**
   * Sort indicator render function
   *
   * @param {object} props
   */
  sortIndicatorRenderer: PropTypes.func,

  /**
   * Mouse action on header row
   *
   * @param {SyntheticEvent} event
   * @param {object} headerCellParams Параметры ячейки заголовка
   */
  onHeaderClick: PropTypes.func,
  onHeaderDoubleClick: PropTypes.func,
  onHeaderMouseOver: PropTypes.func,
  onHeaderMouseOut: PropTypes.func,
  onHeaderRightClick: PropTypes.func,

  /**
   * Mouse action on table row
   *
   * @param {SyntheticEvent} event
   * @param {object} rowCellParams Параметры ячейки строки таблицы
   */
  onRowClick: PropTypes.func,
  onRowDoubleClick: PropTypes.func,
  onRowMouseOver: PropTypes.func,
  onRowMouseOut: PropTypes.func,
  onRowRightClick: PropTypes.func,

  /**
   * Action on table scroll
   *
   * @param {object} params
   *      @see See [React-Windows docs](https://react-window.now.sh/#/api/FixedSizeList)
   */
  onScroll: PropTypes.func,

  /**
   * Action on change column width
   *
   * @param {object} params
   */
  onResizeColumn: PropTypes.func,

  /**
   * Width of vertical table overflow
   */
  overflowWidth: PropTypes.number,

  /**
   * Minimal column width
   */
  minColumnWidth: PropTypes.number,

  /**
   * Maximum column width
   */
  maxColumnWidth: PropTypes.number,

  /**
   * Dynamic width for columns that was not resized
   */
  dynamicColumnWidth: PropTypes.bool,

  /**
   * Props for inner `react-window` list component
   * @see See [React-Windows docs](https://react-window.now.sh/#/api/FixedSizeList)
   */
  listProps: PropTypes.object,

  /**
   * No items in data list label
   */
  noItemsLabel: PropTypes.node,

  /**
   * Hide table header row
   */
  disableHeader: PropTypes.bool,

  /**
   * Auto scroll to list bottom
   */
  autoScroll: PropTypes.bool,

  /**
   * Optional custom CSS class name to attach to root container element
   */
  className: PropTypes.string,

  /**
   * Optional custom id to attach to root container element
   */
  id: PropTypes.string,

  /**
   * DEECOOB FORK: Optional className for header
   */
  headerClassName: PropTypes.string,

  /**
   * DEECOOB FORK: Optional className for headerCells
   */
  headerCellClassName: PropTypes.func,

  /**
   * DEECOOB FORK: Disable columnResizing, default is false
   */
  disableColumnsResizable: PropTypes.bool
};
Table.defaultProps = {
  headerHeight: 30,
  rowHeight: 30,
  onHeaderClick: function onHeaderClick(f) {
    return f;
  },
  onResizeColumn: function onResizeColumn(f) {
    return f;
  },
  onRowClick: function onRowClick(f) {
    return f;
  },
  overflowWidth: 17,
  minColumnWidth: 30,
  dynamicColumnWidth: false,
  noItemsLabel: 'No items'
};

export { Column, ColumnResizer, Header, Row, Table };
